var ProfileInfoView = Backbone.Epoxy.View.extend({
  template: 'components.profile-info',

  bindings: 'data-bind-profile',

  bindingSources: {
    options: new Backbone.Model({ showPasswordFields: true })
  },

  initialize: function (options) {
    this.bindingSources.options.set('showPasswordFields', Boolean(options.showPasswordFields))
  },

  afterRender: function() {
    //You must keep this line if you want to use data binding, otherwise remove it
    this.applyBindings();
    this.$el.find("#birthdayInput").blur();
  }
});

module.exports = ProfileInfoView;
